<mat-toolbar color="primary" class="toolbar">
    <app-back-button [route]="['/home', 'perfil']" color="secondary"></app-back-button>
    <div>{{ "PENDING_COURSES.TITLE" | translate }}</div>
</mat-toolbar>

<div class="content">
    <div fxLayout="row" *ngFor="let course of courses; let i = index" (click)="subscribeCourse(course.id)">
        <div class="listItem" fxFlex>
            <img class="img-curso-custom" [src]="course.urlThumbnail || 'assets/images/default_course.jpg'" />

            <div class="media-body">
                <span class="title text-truncate">
                    {{ course.titulo }}
                </span>
                <div class="instructor">
                    {{ course?.instrutor?.customName ? course?.instrutor?.customName : course?.instrutor?.nome }}
                </div>
                <app-rating-box [rate]="course.rating?.media"> </app-rating-box>
                <mat-chip-list class="course-label" *ngIf="course.label">
                    <mat-chip color="indigo">{{ course.label }}</mat-chip>
                </mat-chip-list>
            </div>
        </div>

        <ng-container *ngIf="isLoading$ | async">
            <ghost-data *ngFor="let ghost of [1, 2, 3, 4, 5]" [show]="true" [opacity]="100 / ghost">
                <div class="listItem">
                    <div class="img-curso-custom">
                        <div class="loader"></div>
                    </div>

                    <div class="media-body">
                        <span class="title"> loading... </span>
                        <div class="instructor">loading...</div>
                    </div>
                </div>
            </ghost-data>
        </ng-container>

        <div class="action" *ngIf="!hasCourses">
            <span class="action-description">>{{ "PENDING_COURSES.NO_DATA" | translate }}</span>
            <span class="material-icons icon"> sentiment_satisfied_alt </span>
        </div>
    </div>
</div>
